import { ServiceMaker, methods, services } from "../services";

export const createTemplateSms = payload =>
  ServiceMaker(
    `/smsemail/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateSms = payload =>
  ServiceMaker(
    `/smsemail/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const fetchSmsTemplateAll = (payload) =>
  ServiceMaker(
    `/smsemail/templates?service=${payload.service}`,
    methods.GET,
    services.master,
    payload
  );
